import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import HamburgerMenu from './components/HamburgerMenu';
import Login from './components/Login';
import App from './App';
import CompletedOrders from './components/CompletedOrders';
import ReturnedItems from './components/ReturnedItems';
import Billing from './components/Billing';

const MainRouter = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(null);

    const handleLogin = ({ username, userRole, carNumber }) => {
        setIsLoggedIn(true);
        setUserDetails({ username, userRole, carNumber });
        localStorage.setItem('loggedInUser', JSON.stringify({ username, userRole, carNumber })); // บันทึกใน LocalStorage
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        setUserDetails(null);
        localStorage.removeItem('loggedInUser'); // ลบจาก LocalStorage
    };

    useEffect(() => {
        const savedUser = localStorage.getItem('loggedInUser');
        if (savedUser) {
            setUserDetails(JSON.parse(savedUser));
            setIsLoggedIn(true);
        }
    }, []);

    return (
        <>
            {isLoggedIn && userDetails ? (
                <>
                    <HamburgerMenu username={userDetails.username} carNumber={userDetails.carNumber}     handleLogout={handleLogout} />
                    <Routes>
                        <Route path="/" element={<App userRole={userDetails.userRole} carNumber={userDetails.carNumber} username={userDetails.username} pageTitle="งานรอส่ง" />} />
                        <Route path="/completed" element={<CompletedOrders userRole={userDetails.userRole} carNumber={userDetails.carNumber} username={userDetails.username} pageTitle="งานที่จบแล้ว" />} />
                        <Route path="/returned" element={<ReturnedItems userRole={userDetails.userRole} carNumber={userDetails.carNumber} username={userDetails.username} pageTitle="ของเหลือกลับร้าน" />} />
                        <Route path="/billing" element={<Billing userRole={userDetails.userRole} carNumber={userDetails.carNumber} username={userDetails.username} pageTitle="คิดเงิน" />} />
                    </Routes>
                </>
            ) : (
                <Login onLogin={handleLogin} />
            )}
        </>
    );
};

export default MainRouter;
